import { Box, Flex, Divider } from "@chakra-ui/react";
import DeleteUserAccountModule from '../user-settings/DeleteUserAccountModule';
import UserChangePasswordModule from '../change-password/UserChangePasswordModule';
import DeleteOrganizationAccountModule from '../user-settings/DeleteOrganizationAccountModule';


export default function UserSettingsManagementModule({
	//Parent Component
	isNoOrgUser,
	firstName,
	lastName,
	isAdministrator,
	orgName
}) {
	return (
		<Flex direction='column' w='100%' className='fade-in'>
			<Flex w='100%' justify='space-between' alignItems={['flex-start', 'center', 'center', 'center']}>
				<Box className="user-profile-section__first-label"> Settings </Box>
			</Flex>

			<Divider />

			<Flex w='100%' mt='2em' direction='column'>
				<UserChangePasswordModule />
				{isNoOrgUser ?
					<>
						<Divider borderColor='gray.300' opacity='50%' pt='5em' />
						<DeleteUserAccountModule firstName={firstName} lastName={lastName} />
					</>
					: isAdministrator &&
					<Box mt='8em' w='100%'>
						<DeleteOrganizationAccountModule orgName={orgName} />
					</Box>
				}
			</Flex>
		</Flex>
	)
}